import React from 'react';
import CustomList from '../../../../core/components/core/Util/List/CustomList/CustomList';
import CustomListContainer from '../../../../core/components/core/Util/List/CustomList/CustomListContainer';
import config from '../../../config/config';
import { loadData } from '../../../../core/components/core/Util/List/CustomList/loadData';

function List() {
    const pathFrontEnd = '/psp-roles/';
    const paths = {
        pathAdd: pathFrontEnd + 'add',
        pathEdit: pathFrontEnd + 'edit',
        pathView: pathFrontEnd + 'view',
        endpointDelete: `${config.endpoints.backend}psp/roles/delete`,
        endpoint: `${config.endpoints.backend}psp/roles/getall`
    };

    const filters = {
        validateOnChange: true,
        showGoBackButton: false,
        showSubmitButton: false,
        handleSubmit: loadData,
        fields: [
            {
                name: 'psp_area_role_id',
                type: 'select',
                label: 'Área de Atuação',
                options: [],
                optionsEndpoint: {
                    endpoint: `${config.endpoints.backend}psp/arearoles/getall`,
                    label: 'name',
                    value: 'id'
                },
                validations: {
                    required: false
                },
                columnSize: 4
            },
            {
                name: 'filtro',
                type: 'submit',
                label: 'Pesquisar',
                columnSize: 1
            },
            {
                name: 'reset',
                type: 'reset',
                label: 'Limpar',
                columnSize: 1
            }
        ]
    };

    let list = {
        labelTitle: 'Lista de Funções',
        labelTitleButtonAdd: 'Incluir nova Função',
        fieldsShowOnDelete: ['name'],
        formFilters: filters,
        columns: [
            {
                name: 'area_role_name',
                label: 'Área de Atuação',
                sortable: true
            },
            {
                name: 'name',
                label: 'Nome da Função',
                sortable: true
            }
        ]
    };

    list = { ...list, ...paths };

    return (
        <div>
            <CustomListContainer
                pathAdd={list.pathAdd}
                labelTitle={list.labelTitle}
                labelTitleButtonAdd={list.labelTitleButtonAdd}
                content={<CustomList list={{ ...list, ...paths }} />}
            />
        </div>
    );
}

export default List;
